export default {
  pageTitle: 'NDDC 店铺配置',
  storeCode: '店铺编码',
  storeName: '店铺名称',
  platformType: '平台类型',
  sapStoreCode: 'SAP 店铺编码',
  inventoryEntityCode: '库存主体编码',
  senderAddress: '地址',
  status: '状态',
  selectData: '请选择一条数据。',
  disableConfirm: '请再次确认是否禁用该门店？',
  activeConfirm: '请再次确认是否启用该门店？',
  disableWrongStatus: '仅可对启用状态的记录执行停用。',
  activeWrongStatus: '仅可对停用状态的记录执行启用。',
  errorcode_8001: '此门店编码已存在，请直接在页面搜索后再进行编辑及更新。',
  errorcode_8002: '此SAP门店编码已存在，请直接在页面搜索后再进行编辑及更新。',
  errorcode_8003: '此shipto已存在，请直接在页面搜索后再进行编辑及更新。',
  errorcode_8004: '此库存主体编码已存在，请直接在页面搜索后再进行编辑及更新。'
}
